'use client'

import { forwardRef } from 'react'

import { TokenInfo, type TokenInfoProps } from './TokenInfo'

export interface CollateralCellProps extends Omit<TokenInfoProps, 'children'> {}

/**
 * CollateralCell component - Tailwind replica of dapp-ui-v5 CollateralCell
 *
 * A convenience wrapper around TokenInfo for displaying collateral assets.
 * Provides the same functionality as TokenInfo with a more semantic name.
 *
 * @example
 * ```tsx
 * <CollateralCell
 *   token={wethToken}
 *   chainId={1}
 *   renderWarnings={<WarningIcon warnings={warnings} />}
 * />
 * ```
 */
const CollateralCell = forwardRef<HTMLDivElement, CollateralCellProps>((props, ref) => {
  return <TokenInfo ref={ref} {...props} />
})

CollateralCell.displayName = 'CollateralCell'

export { CollateralCell }
